import styled from "@mui/material/styles/styled";

import Button, { ButtonProps } from "@rui/Button";
import Link from "@rui/Link";

export const UploadPurchaseCta = styled(
  ({ color: _, ...props }: ButtonProps) => (
    <Button component={Link} variant="contained" disableRipple {...props} />
  )
)(({ color, theme }) => ({
  borderRadius: "4px",
  backgroundColor:
    color === "primary"
      ? theme.palette.shades.primary[500]
      : theme.palette.shades.secondary[100],
  color: color === "primary" ? "#fff" : theme.palette.info.main,
  padding: "8px 12px",
  height: "auto",
  boxShadow: "none",
  "&:hover": {
    backgroundColor:
      color === "primary"
        ? theme.palette.shades.primary[600]
        : theme.palette.shades.secondary[150],
  },
}));
